import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateSubscriptionLevelController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateSubscriptionLevelController.php:15
* @route '/api/admin/workspaces/subscriptions/level'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/admin/workspaces/subscriptions/level',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateSubscriptionLevelController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateSubscriptionLevelController.php:15
* @route '/api/admin/workspaces/subscriptions/level'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateSubscriptionLevelController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateSubscriptionLevelController.php:15
* @route '/api/admin/workspaces/subscriptions/level'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const level = {
    update: Object.assign(update, update),
}

export default level